import type { InjectionKey } from "vue";
import type { ConditionalRequirements } from "./conditionalRules";

export interface ResourcePreloadOptions {
  refreshDependencies?: boolean;
}

export interface ResourcePreloadContext {
  preload: (
    href: string,
    options?: ResourcePreloadOptions,
  ) => Promise<boolean>;
  isReady: (href: string) => boolean;
  loadConditions?: (
    requirements: ConditionalRequirements,
  ) => Promise<void>;
}

export const ResourcePreloadKey: InjectionKey<ResourcePreloadContext> =
  Symbol("resource-preload");
